import { Box, Text } from "@mantine/core";

export const ViewportSizeName = () => {
  const sizes = ["xs", "sm", "md", "lg", "xl"];
  const colors = ["red", "white", "blue", "green", "yellow"];

  return (
    <Box
      style={{
        position: "fixed",
        left: 0,
        top: 0,
        display:
          import.meta.env.DEV && window.location.href.includes("localhost")
            ? "block"
            : "none",
      }}
    >
      {sizes.map((size, index) => {
        return (
          <Text
            key={size}
            px={4}
            fz="xs"
            bg={colors[index]}
            display={{
              base: "none",
              xs: size === "xs" ? "block" : "none",
              sm: size === "sm" ? "block" : "none",
              md: size === "md" ? "block" : "none",
              lg: size === "lg" ? "block" : "none",
              xl: size === "xl" ? "block" : "none",
            }}
          >
            {size}
          </Text>
        );
      })}
    </Box>
  );
};
